<script>
  import { ComponentType } from '../../../../js/constants';
  import { getNavState, initDrawerTop, getAccessibilityRedesignRenderState } from '../../../../js/stores';

  import HomeLink from '../HomeLink/HomeLink.svelte';
  import Menu from './Menu/Menu.svelte';
  import Cart from './Cart/Cart.svelte';
  import Scrim from './Scrim/Scrim.svelte';
  import BodyScrollLocker from './BodyScrollLocker/BodyScrollLocker.svelte';

  export let data = {};
  export let mobileMode;

  const navStateStore = getNavState();
  const drawerTopStore = initDrawerTop();
  const accessibilityRedesignRender = getAccessibilityRedesignRenderState();

  $: alignment = data.alignment || 'center';

  let nav; // bound to nav element below
  let height; // bound to nav's offsetHeight below

  $: if (nav && height) {
    $drawerTopStore = height + nav.getBoundingClientRect().top + window.scrollY;
  }

  function closeDrawers() {
    $navStateStore = {
      ...$navStateStore,
      drawer: null,
      category: null,
      subcategory: null,
    };
  }
</script>

<nav
  class="MobileNav align-{alignment}"
  class:mobile-nav-accessibility-redesign={$accessibilityRedesignRender}
  data-component-type={ComponentType.MAIN_NAVIGATION}
  bind:this={nav}
  bind:offsetHeight={height}
>
  {#if data.primaryNavItems || data.secondaryNavItems || data.cart}
    <div class="left-slot">
      <HomeLink {...data.home} />
    </div>
    <div class="right-slot">
      {#if data.cart}
        <Cart data={data.cart} />
      {/if}
      {#if data.primaryNavItems || data.secondaryNavItems}
        <Menu {data} {mobileMode} />
      {/if}
    </div>
  {:else}
    <HomeLink {...data.home} />
  {/if}
</nav>

<Scrim isVisible={Boolean($navStateStore.drawer)} on:click={closeDrawers} />

<BodyScrollLocker isLocked={Boolean($navStateStore.drawer)} />

<style>.MobileNav {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  box-sizing: border-box;
  position: relative;
  min-width: 320px;
  border-bottom-width: 1px;
  z-index: 3;
  display: flex;
  padding: 15px;
}
@media (min-width: 1280px) {
  .MobileNav {
    display: none;
  }
}

.mobile-nav-accessibility-redesign {
  padding: 13px 15px;
}

.align-left {
  justify-content: flex-start;
}

.align-center {
  justify-content: center;
}

.align-right {
  justify-content: flex-end;
}

.left-slot,
.right-slot {
  display: flex;
  align-items: center;
  width: 100%;
  flex: 0 1 auto;
}

.left-slot {
  justify-content: flex-start;
}

.right-slot {
  justify-content: flex-end;
}</style>
